module.exports = __webpack_public_path__ + "static/media/bnr2.8a4fd015.jpg";